import { Component, ElementRef, Injector, Type } from "@angular/core";
import { trigger, state, style, transition, animate } from "@angular/animations";

import { BfxFindOrdersContextMenuService } from "./bfx-find-orders-contextmenu.service";

import {
  BfxBlotterOrdersContextMenuItem,
  OrderDataPrimaryLookupService,
} from "shared/cubiq-services";

import { BfxBlotterOrdersContextMenu } from "app/bfx-blotter-orders/bfx-blotter-orders-contextmenu";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-find-orders-context-menu",
  templateUrl: "./html/bfx-find-orders-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  styleUrls: ["../bfx-base-blotter/bfx-base-blotter-contextmenu.less"],
  standalone: false,
})
export class BfxFindOrdersContextMenu extends BfxBlotterOrdersContextMenu {
  constructor(
    injector: Injector,
    lookupService: OrderDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BfxFindOrdersContextMenuService> {
    return BfxFindOrdersContextMenuService;
  }

  // TODO: move to base and refactor others
  public isItemEnabled(item: BfxBlotterOrdersContextMenuItem) {
    if (item == null) {
      return false;
    }
    return item.state.enabled;
  }
}
